import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { IS_B2B } from '@/domains/core/settings/constants';
import { AlgoliaSearchInsights } from '@/domains/productDiscovery/algolia/searchInsights/AlgoliaSearchInsights';

export const useAlgoliaCVRTracking = (): void => {
  const router = useRouter();
  /*TODO: this was a call to 'useFeatureFlags' replaced with the value of the flag/abtest. Consider removing this call when you modify the file.*/
  const [isAlgoliaSearchInsightsTrackingEnabled, isB2CEnabled] = [true, true];

  useEffect(() => {
    if (
      (IS_B2B && isAlgoliaSearchInsightsTrackingEnabled) ||
      (!IS_B2B && isB2CEnabled)
    ) {
      window.addEventListener(
        'unload',
        AlgoliaSearchInsights.clearCvrQueryData,
      );
      router.events.on(
        'routeChangeStart',
        AlgoliaSearchInsights.clearCvrQueryData,
      );
    }
    return () => {
      if (
        (IS_B2B && isAlgoliaSearchInsightsTrackingEnabled) ||
        (!IS_B2B && isB2CEnabled)
      ) {
        window.removeEventListener(
          'unload',
          AlgoliaSearchInsights.clearCvrQueryData,
        );
        router.events.off(
          'routeChangeStart',
          AlgoliaSearchInsights.clearCvrQueryData,
        );
      }
    };
  }, [isAlgoliaSearchInsightsTrackingEnabled, isB2CEnabled, router]);
};
